import Button, { ButtonProps } from '@material-ui/core/Button/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';

interface LoadingButtonProps extends ButtonProps {
  isLoading: boolean;
  loaderSize?: number;
}
const LoadingButton = ({ isLoading, loaderSize, disabled, ...props }: LoadingButtonProps) => (
  <Button
    startIcon={isLoading ? <CircularProgress size={loaderSize} color="secondary" /> : null}
    disabled={isLoading || disabled}
    {...props}
  >
    {props.children}
  </Button>
);
export default LoadingButton;
